import React from "react";
import { Drawer } from "antd";

import TemplateComposer from "./TemplateComposer";

/**
 * Bulk send from the leads list. The per-lead flow lives inside the Add Lead
 * Activity form instead; both share TemplateComposer.
 */
const SendTemplateDrawer = ({
  open,
  onClose,
  channel = "EMAIL",
  leads = [],
  recordType = "lead",
  onSent,
}) => (
  <Drawer
    title={channel === "EMAIL" ? "Send Email from Template" : "Send WhatsApp Template"}
    placement="right"
    width="70%"
    open={open}
    onClose={onClose}
    style={{ zIndex: 20 }}
    destroyOnClose
  >
    <TemplateComposer
      channel={channel}
      leads={leads}
      recordType={recordType}
      showActions
      onSent={onSent}
    />
  </Drawer>
);

export default SendTemplateDrawer;
